module.exports = __webpack_public_path__ + "assets/img/35-s.03c99c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/35-s.jpg
// module id = y+t4
// module chunks = 0